import * as amplitude from "@amplitude/analytics-browser";
import { memo, useEffect, useState } from "react";
import { useGetCurrentUser } from "~/api/users/users";
import { AMPLITUDE_API_KEY, AMPLITUDE_SERVER_URL } from "~/constants/index";
import { enableForEnv, Stages } from "~/lib/utils";
import { useAuthStore } from "~/stores/authStore";
import AmplitudeSessionReplay, {
  enableAmplitudeSessionReplay,
} from "./AmplitudeSessionReplay";

const AmplitudeProvider = ({ children }: { children: React.ReactNode }) => {
  const { data: user } = useGetCurrentUser();
  const [isInitialized, setIsInitialized] = useState(false);
  const isImpersonating = useAuthStore((s) => s.isImpersonating);

  useEffect(() => {
    if (isImpersonating) return;
    if (!user?.email || isInitialized) return;
    if (enableForEnv([Stages.PRODUCTION])) {
      amplitude.init(AMPLITUDE_API_KEY, {
        serverUrl: AMPLITUDE_SERVER_URL,
      });
      amplitude.identify(new amplitude.Identify().set("email", user.email));
      amplitude.setUserId(user.email);
      setIsInitialized(true);
    }
  }, [user?.email, isInitialized, isImpersonating]);

  return (
    <>
      {children}
      {enableAmplitudeSessionReplay() && <AmplitudeSessionReplay />}
    </>
  );
};

export default memo(AmplitudeProvider);
